// @see my.staging.liquidweb.com
import type { AppConfigI } from './example';

const staging: AppConfigI = {
	baseURL: 'https://api-public.staging.liquidweb.com/',
	session: {
		length: 900,
		warningTime: 150,
	},
	hosts: {
		www: 'stg-marketing.liquidweb.com',
		cart: 'cart.staging.liquidweb.com',
		manage: 'manage.staging.liquidweb.com',
		salesforce: 'liquidweb--scdev.sandbox.lightning.force.com/lightning/r',
		customer_community: 'liquidweb--scdev.sandbox.my.site.com/customer/s',
		managed_apps: 'app.staging.liquidweb.com',
		authorize_net: 'test.authorize.net',
		gator: 'gator.staging.liquidweb.com',
	},
	gaTrackerId: 'G-RWVHZPXV4N',
	gtmContainerId: 'GTM-PQFRHRZH',
	cartStack: {
		siteId: 'k5FaX1lK',
		trackingScriptUrl:
			'https://api.cartstack.com/js/customer-tracking/cart.msmallwood.dev.liquidweb.com:20250_e26c5744de270f74b9fb65dd70ae774c.js',
	},
	guestAuth: {
		username: 'remote-signup',
		password: 'r3M0t3s|gnup',
	},
	cart: {
		checkoutURL: 'https://stg-marketing.liquidweb.com/cart/checkout',
		configURL: 'https://stg-marketing.liquidweb.com/configuration',
		cookieDomain: 'liquidweb.com',
		payPalSystem: 'portal_lw',
		payPalSignUpSystem: 'portal_signup_lw',
	},
	chatConfig: {
		enabled: true,
		orgId: '00DWe000002ZeB7',
		deploymentId: 'Liquid_Web_Support_Portal_MIAW',
		communityURL:
			'https://liquidweb--developer.sandbox.my.site.com/ESWLiquidWebSupportPor1740147560083',
		scrt2URL: 'https://liquidweb--developer.sandbox.my.salesforce-scrt.com',
		messagingScriptURL:
			'https://liquidweb--developer.sandbox.my.site.com/ESWLiquidWebSupportPor1740147560083/assets/js/bootstrap.min.js',
		settings: {
			language: 'en_US',
			chatButtonPosition: '32px,32px',
		},
		storageDomain: 'myuat.dev.liquidweb.com',
	},
	openId: {
		client_id: 'lw-portal',
		authority: 'https://login.staging.liquidweb.com',
		accessTokenExpiringNotificationTime: 1200,
	},
	algolia: {
		applicationId: 'PW72AQI7GT',
		searchOnlyApiKey: '68dddee3207e5fc6a1d4b936de592fbd',
	},
	feedback: {
		boardToken: 'e61b5710-cb70-9393-be21-a44ed0dc1f1d',
	},
	googleMapsApiKey: 'AIzaSyCp1q6YD7Sqz-XNwB8XV5VCetTr-JcQVMc',
	acceptJs: {
		src: 'https://js.authorize.net/v1/Accept.js',
		merchantKeys: {
			'65HksN97':
				'9E8G988CRTtEsMcLhnFdvg947ArCyBB93TH7Q7Ny4kvLx9ntxw58Lf7cmtcLCSNu',
			'8HH729nFtQ':
				'566WwmKxHh5UBhHvcHMgP96ZQ8XmjR3eCkW3Xg759QrfXAz2wUca3WPgzm9ugWwa',
			'8R89bPjL':
				'3pbSVBb422mQbFk7TAdB4p5tdEampd6XyAzeEP72BhxfWTHR873tPh8EDg8PQ9pz',
			hnzr87b:
				'4e32vp3u9EEsC3qSF9baCu6rJvE9uPVRytX2X53RHxUt8x8QkFAyJ34qsXLcz2Md',
			'3at84NWq':
				'7TgbupC8GTSNRj2f3mpKcvYvtx3yzfD65Nz9Z3FW3Rk5yzp56FSQpCEVHy57J5u8',
		},
		fallbackMerchant: {
			key: '4e32vp3u9EEsC3qSF9baCu6rJvE9uPVRytX2X53RHxUt8x8QkFAyJ34qsXLcz2Md',
			id: 'hnzr87b',
		},
	},
	theme: 'liquidweb',
	brand: 'liquidweb',
};

export default staging;
